import api from './api';

const standardsService = {
  getAllStandards: async () => {
    const response = await api.get('/api/standards/all');
    return response.data;
  }
};

export default standardsService;
